// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyArjO8QuS5TfLkQmedGT_yNzHrIblWFGwk",
  authDomain: "nuance-radio-307ee.firebaseapp.com",
  projectId: "nuance-radio-307ee",
  storageBucket: "nuance-radio-307ee.appspot.com",
  messagingSenderId: "225049358153",
  appId: "1:225049358153:web:YOUR_APP_ID" // This needs to be updated with the actual App ID
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app); 
export const db = getFirestore(app);

// Ensure auth state is stored in long-lived browser storage (stay logged in)
setPersistence(auth, browserLocalPersistence).catch(() => {
  // If persistence setting fails (e.g. in some embedded contexts), Firebase will fall back to its default.
});